<!--*****************************************-->
<!--Animation examples-->
<!--https://dreambo8563.github.io/vue-particle-effect-buttons/-->
<!--https://github.com/chenxuan0000/svg-progress-bar-->
<!--https://tinymotion.me/#hover-->
<!--https://github.com/valgeirb/vue-confetti-explosion-->
<!--https://www.vuescript.com/confetti-animation-effect-vue-js/-->
<!--https://www.vuescript.com/3d-page-flip-effect-flipbook/-->
<!--*****************************************-->
<template>
    <div class="page noselect">
        <!--<div class="absBack"> -->
        <!--           <div onclick="window.history.back()"> -->
        <!--                <v-icon medium dark>mdi-arrow-left</v-icon> -->
        <!--            </div> -->
        <!--        </div> -->

        <!--        <h1 class="myTitle">Datenschutz</h1>-->

        <v-container fluid grid-list-lg>
            <div class="spacer-15"></div>

            <div class="mt-3 mb-6 text-center" v-if="!$store.getters.loggedIn">
                <v-btn
                       color="primary" rounded medium class="btn-df"
                       @click="$ebus.$emit('goto', {name:'Registrierung'})"
                >Zur Registrierung
                    <v-icon right medium>mdi-arrow-right</v-icon>
                </v-btn>
            </div>

            <div class="rahmen">
                <div class="text-center mb-2">
                    <StempelAnzahl></StempelAnzahl>
                </div>
                <v-row class="">
                    <!--                    <v-col cols="4" xs="3" sm="3" v-for="stempel in 10">-->
                    <v-col cols="3" v-for="stempel in 10" class="pa-1">
                        <div class="superCenter" v-if="stempel <= stempelCounter">
                            <img class="stempelImage" src="../assets/loyalty/Qstempel.png">
                        </div>
                        <div class="superCenter" v-else>
                            <div class="circle"></div>
                        </div>
                    </v-col>
                </v-row>
            </div>

            <div class="text-left mt-7 mb-4">
                <div>
                    <h4>Information</h4>
                    Als <span class="text-decoration-underline pointer"
                              @click="goAccountOrSignin"
                >registrierter Nutzer</span> kannst du Stempel sammeln.
                    Für jede 10 Euro Umsatz erhälst du einen Stempel.
                    Bei 10 Stempel erhälst du {{$store.getters.stempelRabattAmount}} Euro Rabatt auf die nächste Bestellung
                    oder eine zukünftigen Bestellung deiner Wahl.
                </div>
            </div>

            <!--            <div class="mt-4"></div>-->

            <!--            <div class="rahmen">-->
            <!--                <v-layout row wrao>-->
            <!--                    <v-flex xs4 v-for="stempel in 10">-->
            <!--                        <div class="scontainer maxh">-->
            <!--                            <div class="superCenter" v-if="stempel <= stempelCounter">-->
            <!--                                <img class="stempelImage" src="../assets/loyalty/Qstempel.png">-->
            <!--                            </div>-->
            <!--                            <div class="superCenter" v-else>-->
            <!--                                <div class="circle"></div>-->
            <!--                            </div>-->
            <!--                        </div>-->
            <!--                    </v-flex>-->
            <!--                    <v-flex xs6>-->
            <!--                        <div class="maxh">-->
            <!--                            <div class="superCenter">-->
            <!--                                <div class="text-center">-->
            <!--                                    <div class="font-size:0.85em">..noch {{(100 - -->
            <!--                                        $store.getters.stempelkarte.punktestand)}} Punkte fehlen für-->
            <!--                                    </div>-->
            <!--                                    <h3 class="text-center">30 € Gutschein</h3>-->
            <!--                                </div>-->

            <!--                            </div>-->
            <!--                        </div>-->
            <!--                    </v-flex>-->
            <!--                </v-layout>-->
            <!--            </div>-->

            <div class="mt-4"></div>
            <!--            <v-layout row wrap>-->
            <!--                <v-flex xs7>-->
            <!--                    <v-btn class="btn-df okBtn text-none"-->
            <!--                           @click.native.passive="addPunkte(10)"-->
            <!--                    >-->
            <!--                        <v-icon left medium class="myWhite">-->
            <!--                            mdi-plus-circle-outline-->
            <!--                        </v-icon>-->
            <!--                        10 Punkte-->
            <!--                    </v-btn>-->
            <!--                </v-flex>-->
            <!--                &lt;!&ndash;                <v-flex xs5>&ndash;&gt;-->
            <!--                &lt;!&ndash;                    <v-btn class="btn-df grayBtn text-none"&ndash;&gt;-->
            <!--                &lt;!&ndash;                           @click.native.passive="reset"&ndash;&gt;-->
            <!--                &lt;!&ndash;                    >&ndash;&gt;-->
            <!--                &lt;!&ndash;                        Reset&ndash;&gt;-->
            <!--                &lt;!&ndash;                    </v-btn>&ndash;&gt;-->
            <!--                &lt;!&ndash;                </v-flex>&ndash;&gt;-->
            <!--            </v-layout>-->
        </v-container>


        <!--        <div class="fixWinner" v-if="showWinner">-->
        <!--            <v-container grid-list-lg>-->
        <!--                <v-layout row wrap>-->
        <!--                    <v-flex xs12>-->
        <!--                        <canvas id="confettiCanvas"></canvas>-->
        <!--                        <div class="scontainer maxh">-->
        <!--                            <div class="superCenter">-->
        <!--                                <div class="text-center">-->
        <!--                                    <h1 class="winnerText">Du hast einen 30 € Gutschein erhalten!</h1>-->
        <!--                                </div>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                    </v-flex>-->
        <!--                </v-layout>-->
        <!--            </v-container>-->
        <!--        </div>-->


    </div>
</template>

<script>
    import {ebus} from '../vendor/ebus';
    import store from '../store/store'
    import * as util from "@/vendor/util";
    import StempelAnzahl from "../stempelkarte/StempelAnzahl";

    export default {
        components: {StempelAnzahl},
        data: () => ({
            showWinner: false,
        }),

        computed: {
            punktestand() {
                return store.getters.stempelkarte.punktestand;
            },
            stempelCounter() {
                let p = this.punktestand;
                let r = 0;
                if (p > 0) {
                    r = 1;
                }
                let t = Math.trunc(p / 10);
                if (t > 1) {
                    r = t;
                }
                if (r > 10) {
                    r = 10;
                }
                return r;
            },
            //     url() {
            //         // return 'https://static.qsignal.eu/sudhauswarstein/legal/datenschutz.html'
            //         return 'https://' + window.location.host + '/legal/datenschutz.html'
            //     }
        },

        beforeMount() {
            ebus.$emit('loadStempelkarte', false);
        },

        // activated() {
        //     util.jumpToTop(true);
        // },

        // deactivated() {
        //     // try {
        //     //     window.removeEventListener("message", this.processSizeUpdate);
        //     // } catch (e) {
        //     //     console.log('Error removing processSizeUpdate: ' + e.message);
        //     // }
        // },

        methods: {
            goAccountOrSignin() {
                if (this.$store.getters.loggedIn) {
                    this.$router.push({name: 'Account'});
                } else {
                    this.$router.push({name: 'Anmelden'});
                }
            },
            // addPunkte(x) {
            //     let r = store.getters.stempelkarte.punktestand;
            //     r = r + x;
            //     if (r >= 100) {
            //         r = 100;
            //     }
            //     store.commit('stempelkarte', {punktestand: r});
            //
            //     if (r === 100) {
            //         this.winningAnimation();
            //     }
            // },

            reset() {
                // store.getters.stempelkarte.punktestand = 35;
            },

            winningAnimation() {
                this.showWinner = true;
                this.showConfetti();
                setTimeout(() => {
                    this.reset();
                    this.showWinner = false
                }, 4500);
            },

            showConfetti() {
                // const canvas = document.getElementById('confettiCanvas');
                // const jsConfetti = new JSConfetti({canvas});
                // jsConfetti.addConfetti({
                //     emojis: ['✨', '🌯'],
                //     emojiSize: 25,
                //     confettiNumber: 60,
                // });
                //
                // jsConfetti.addConfetti();
                // setTimeout(() => {
                //     jsConfetti.addConfetti();
                // }, 900);
                // setTimeout(() => {
                //     jsConfetti.addConfetti();
                // }, 1800);

            },

        },
    }
</script>

<style scoped lang="scss">
    @import '../styles/base';
    @import '../styles/stempel';

    $colorStrongGelb: yellow;

    $colorCirle: $stempelTextColor;

    .fixWinner {
        position: fixed;
        z-index: 150;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: $color-secondary;
    }

    .winnerText {
        color: $color-primary !important;
    }


    .rahmen {
        margin: 0 20px;
        background-color: $stempelBgColor;
        padding: 18px;
        border-radius: 25px;
        color: $stempelTextColor;
        /*<!--border: 2px solid $stempelTextColor;-->*/
    }

    .rahmen ::v-deep * {
        color: $stempelTextColor;
    }

    .scontainer {
        padding: 5px;
    }

    .stempelImage {
        width: 100%;
        max-width: 150px;
    }

    .circle {
        border: 2px dashed $colorCirle;
        -moz-border-radius: 75px;
        -webkit-border-radius: 75px;
        width: 80%;
        aspect-ratio: 1;
        max-width: 150px;
    }

</style>
